import { Link } from 'react-router-dom';
import { Logo } from './Nav';

const COLS = [
  { h: 'Product', links: [['Features', '/features'], ['AI Editor', '/ai-editor'], ['Voiceover', '/voiceover'], ['Music', '/music'], ['Shorts', '/shorts']] },
  { h: 'Solutions', links: [['Templates', '/templates'], ['Images & B-roll', '/images-broll'], ['Pricing', '/pricing']] },
  { h: 'Resources', links: [['Blog', '/blog'], ['Help', '/help'], ['Log in', '/login'], ['Sign up', '/signup']] },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0B0C12] mt-24">
      <div className="max-w-7xl mx-auto px-5 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Logo />
          <p className="text-slate-400 text-sm mt-4 max-w-xs leading-relaxed">
            AI Video Transformation Platform. Upload. Analyze. Edit. Revoice. Enhance. Publish.
          </p>
        </div>
        {COLS.map((c) => (
          <div key={c.h}>
            <div className="font-mono text-xs uppercase tracking-widest text-slate-500 mb-4">{c.h}</div>
            <ul className="space-y-2.5">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500 font-mono">
        © 2026 TubeEditor AI — AI does the first 80% of the editing. You approve the result.
      </div>
    </footer>
  );
}
